/* globals angular */
// Substitui o `ui-br-cpfcnpj-mask` (angular-br-validations), que aceita apenas
// dígitos. A IN RFB nº 2.229/2024 permite letras [A-Z] nas 12 primeiras posições
// do CNPJ a partir de julho/2026, mantendo numéricos os 2 dígitos verificadores.
//
// API:
//   <input ng-model="value" mandae-cpf-cnpj-mask>
// $error.cpf  → CPF inválido (11 dígitos, módulo 11)
// $error.cnpj → CNPJ inválido (14 caracteres alfanuméricos + DV)
(function () {
  'use strict';

  function sanitize(value) {
    return (value || '').toString().toUpperCase().replace(/[^A-Z0-9]/g, '');
  }

  function formatCpf(clean) {
    var out = clean.substr(0, 3);
    if (clean.length > 3) { out += '.' + clean.substr(3, 3); }
    if (clean.length > 6) { out += '.' + clean.substr(6, 3); }
    if (clean.length > 9) { out += '-' + clean.substr(9, 2); }
    return out;
  }

  function formatCnpj(clean) {
    var out = clean.substr(0, 2);
    if (clean.length > 2) { out += '.' + clean.substr(2, 3); }
    if (clean.length > 5) { out += '.' + clean.substr(5, 3); }
    if (clean.length > 8) { out += '/' + clean.substr(8, 4); }
    if (clean.length > 12) { out += '-' + clean.substr(12, 2); }
    return out;
  }

  function applyFormat(clean) {
    if (!clean) { return ''; }
    // Trocar para CNPJ assim que detectarmos uma letra evita formatar um CNPJ
    // alfanumérico em meio à digitação como se fosse CPF (ponto em posição errada).
    var hasLetters = /[A-Z]/.test(clean);
    return (clean.length <= 11 && !hasLetters) ? formatCpf(clean) : formatCnpj(clean);
  }

  function isAllSameChars(value) {
    return new RegExp('^(.)\\1{' + (value.length - 1) + '}$').test(value);
  }

  function calcCnpjDv(base, length) {
    var soma = 0;
    var pos = length - 7;
    for (var i = length; i >= 1; i--) {
      soma += (base.charCodeAt(length - i) - 48) * pos--;
      if (pos < 2) { pos = 9; }
    }
    return soma % 11 < 2 ? 0 : 11 - (soma % 11);
  }

  function validCpf(value) {
    if (!/^\d{11}$/.test(value) || isAllSameChars(value)) { return false; }
    var sum = 0;
    for (var i = 0; i < 9; i++) { sum += +value.charAt(i) * (10 - i); }
    var dv1 = 11 - (sum % 11);
    if (dv1 >= 10) { dv1 = 0; }
    if (dv1 !== +value.charAt(9)) { return false; }
    sum = 0;
    for (var j = 0; j < 10; j++) { sum += +value.charAt(j) * (11 - j); }
    var dv2 = 11 - (sum % 11);
    if (dv2 >= 10) { dv2 = 0; }
    return dv2 === +value.charAt(10);
  }

  function validCnpj(value) {
    if (!/^[A-Z0-9]{12}\d{2}$/.test(value) || isAllSameChars(value)) { return false; }
    if (calcCnpjDv(value.substr(0, 12), 12) !== +value.charAt(12)) { return false; }
    return calcCnpjDv(value.substr(0, 13), 13) === +value.charAt(13);
  }

  function mandaeCpfCnpjMask() {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function (scope, element, attrs, ngModel) {
        function formatter(modelValue) {
          return applyFormat(sanitize(modelValue));
        }

        function parser(viewValue) {
          var clean = sanitize(viewValue);
          var maxLength = clean.length > 11 ? 14 : 11;
          if (clean.length > maxLength) {
            clean = clean.substr(0, maxLength);
          }
          var formatted = applyFormat(clean);
          if (formatted !== viewValue) {
            ngModel.$setViewValue(formatted);
            ngModel.$render();
          }
          return clean;
        }

        ngModel.$formatters.unshift(formatter);
        ngModel.$parsers.unshift(parser);

        ngModel.$validators.cpf = function (modelValue) {
          if (!modelValue) { return true; }
          if (modelValue.length !== 11) { return true; }
          return validCpf(modelValue);
        };

        ngModel.$validators.cnpj = function (modelValue) {
          if (!modelValue) { return true; }
          if (modelValue.length !== 14) { return true; }
          return validCnpj(modelValue);
        };
      }
    };
  }

  angular
    .module('mandaeApp')
    .directive('mandaeCpfCnpjMask', mandaeCpfCnpjMask);
}());
